import React from "react";
import { Button } from "../../../Atoms";
import { useNavigate } from 'react-router-dom';

const solutions = [
    { label: "Site Services", title: ["Consultation", "Site Evaluation"], number: 1 },
    { label: "Solutions Proposal", title: ["Requirement Check", "Technical Inspection"], number: 2 },
    { label: "Standard Support", title: ["Hardware & Software Updates", "Remote Diagnostics", "365 days Connectivity"], number: 3 },
];

const rowLayout = [
    ["60", "40"], // Row 1
    ["40", "60"], // Row 2    
];

const FourSteps = () => {
    const navigate = useNavigate();
    return (
        <section className="bg-light-gradient-white blade-padding-sm">
            <div className="containers-min mx-auto px-4 py-12">
                <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
                    <h3 className="text-center font-gilroy">
                        CPO Support
                    </h3>
                    <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                        We're here to give you best-in-class support so your chargers are up and running every time you need them
                    </p>
                </div>


                {/* Render 3 Rows */}
                <div className="space-y-4 mb-8">
                    {Array.from({ length: Math.ceil(solutions.length / 2) }).map((_, rowIndex) => {
                        const first = solutions[rowIndex * 2];
                        const second = solutions[rowIndex * 2 + 1];
                        const isSingle = !second;

                        const renderCard = (item) => (
                            <div
                                className="bg-gray-200 p-8 rounded-xl flex items-center justify-between font-semibold text-left w-full flex-col sm:flex-row"
                                style={{ flex: isSingle ? "1 1 100%" : "1 1 50%" }}
                            >
                                <div className="flex flex-col space-y-2">
                                    <span className="text-2xl font-semibold mb-2 font-gilroy">{item.label}</span>
                                    <ul className="list-disc list-inside font-light flex flex-col sm:flex-row sm:space-x-6">
                                        {item.title.map((line, idx) => (
                                            <li key={idx} className="text-gray-600 text-lg font-poppins">{line}</li>
                                        ))}
                                    </ul>
                                </div>
                                <span className="text-6xl font-bold text-gray-500 font-poppins hidden sm:block">{item.number}</span>
                            </div>
                        );

                        return (
                            <div
                                key={rowIndex}
                                className="flex flex-col md:flex-row gap-4"
                            >
                                {renderCard(first)}
                                {second && renderCard(second)}
                            </div>
                        );
                    })}
                </div>


                {/* CTA Footer */}
                <div className="bg-gradient text-black rounded-xl px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xl lg:text-2xl font-semibold w-3/4 font-poppins">
                        Let's electrify your operations together
                    </p>
                    <Button
                        title="Talk to an expert"
                        onClick={() => navigate('/get-in-touch')}
                    />
                </div>
            </div>
        </section>
    );
};

export default FourSteps;
